<template>
  <DeleteClientModal />
  <CreateClientModal />
  <UpdateClientModal />
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <div class="d-flex align-items-center">
        <a
          class="clients-create-btn default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateClientModal"
        >
          <span class="d-none d-md-inline me-2">Criar novo cliente</span>
          <i class="flaticon-plus position-relative fs-12"></i>
        </a>
      </div>
      <div class="d-flex align-items-center w-100 ms-lg-auto" style="max-width: 350px; position: relative; z-index: 99;">
        <multiselect
          ref="clientSelect"
          v-model="selectedSearchClient"
          :options="getSalesContacts"
          :searchable="true"
          :loading="isLoadingClients"
          :internal-search="false"
          :custom-label="formatClientOption"
          :taggable="false"
          label="phone"
          track-by="id"
          no-options-text="Nenhum cliente encontrado."
          no-result-text="Nenhum resultado para sua busca."
          placeholder="Buscar cliente..."
          @search-change="debouncedFetchClients"
          @select="onClientSelect"
          :close-on-select="true"
          id="client_search"
          class="w-100"
        >
          <template #noOptions>
            <div>Comece a digitar para buscar clientes.</div>
          </template>
          <template #noResult>
            Nenhum cliente encontrado
          </template>
        </multiselect>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Nome
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Email
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Telefone
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Data Nasc.
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Editar
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Deletar
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(value, key) in getClientsList" :key="key">
              
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ value.name != '' && value.name != null  ? value.name : 'Sem nome' }}
                  </div>
                </div>
              </th>
              
              <td class="shadow-none lh-1 fw-medium">
                {{ value.email != '' && value.email != null  ? value.email : 'Sem email' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <a :href="`https://wa.me/55${value.phone}`" target="_blank" class="text-decoration-none">
                  {{ value.phone }}
                </a>
              </td>

              <td class="shadow-none lh-1 fw-medium">
                {{ value.birth_date ? formatBirthDate(value.birth_date) : '' }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="openClientInfoTab(value)" data-bs-toggle="modal" data-bs-target="#UpdateClientModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="setCurrentDeleteClient(value)" data-bs-toggle="modal" data-bs-target="#DeleteClientModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

            </tr>
          
          </tbody>
        </table>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center mt-20">
        <div class="fs-14 text-muted mb-10 mb-sm-0">
          Página {{ currentPage }} de {{ getClientsPagination.last_page || 1 }} —
          Total de {{ getClientsPagination.total || getClientsList.length }} clientes
        </div>
        <nav aria-label="Paginação de clientes">
          <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: currentPage <= 1 }">
              <button type="button" class="page-link" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">
                Anterior
              </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage >= getClientsPagination.last_page }">
              <button type="button" class="page-link" @click="goToPage(currentPage + 1)" :disabled="currentPage >= getClientsPagination.last_page">
                Próxima
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import DeleteClientModal from './DeleteClientModal.vue';
import CreateClientModal from './CreateClientModal.vue';
import UpdateClientModal from './UpdateClientModal.vue';

export default defineComponent({
  name: "ClientsList",
  data() {
    return {
      currentPage: 1,
      selectedSearchClient: null,
      isLoadingClients: false,
      lastClientQuery: '',
      clientFetchTimer: null,
      pendingClientQuery: ''
    };
  },
  computed: {
    ...mapGetters([
      'getClientsList',
      'getClientsPagination',
      'getSalesContacts'
    ])
  },
  components: {
    DeleteClientModal,
    CreateClientModal,
    UpdateClientModal,
    Multiselect
  },
  mounted() {
    this.loadPage(1);
  },
  methods: {
    ...mapActions([
      "setClientsList",
      "setCurrentDeleteClient",
      "setCurrentUpdateClient",
      "setCurrentUpdateClientTab",
      "setSalesContacts"
    ]),
    openClientInfoTab(client) {
      this.setCurrentUpdateClientTab('info');
      this.setCurrentUpdateClient(client);
    },
    formatClientOption(client) {
      return `${client.name ? client.name : 'Sem nome'} - ${client.phone || ''}`;
    },
    async fetchClients(query) {
      if (!query || query.length < 2 || query === this.lastClientQuery) return;

      this.lastClientQuery = query;
      this.isLoadingClients = true;

      try {
        await this.setSalesContacts(query);
      } catch (error) {
        console.error('Erro ao buscar clientes:', error);
      } finally {
        this.isLoadingClients = false;
      }
    },
    debouncedFetchClients(query: string) {
      this.pendingClientQuery = query;

      if (this.clientFetchTimer) {
        clearTimeout(this.clientFetchTimer as any);
      }

      this.clientFetchTimer = setTimeout(() => {
        this.fetchClients(this.pendingClientQuery);
        this.clientFetchTimer = null;
      }, 600) as any;
    },
    onClientSelect(client: any) {
      this.setCurrentUpdateClientTab('info');
      this.setCurrentUpdateClient(client);

      this.$nextTick(() => {
        const modalEl = document.getElementById('UpdateClientModal');
        if (!modalEl) return;
        
        if (window.bootstrap && window.bootstrap.Modal) {
          try {
            const modalInstance = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
            modalInstance.show();
          } catch(e) {
            let btn = document.createElement('button');
            btn.setAttribute('data-bs-toggle', 'modal');
            btn.setAttribute('data-bs-target', '#UpdateClientModal');
            document.body.appendChild(btn);
            btn.click();
            document.body.removeChild(btn);
          }
        } else {
          let btn = document.createElement('button');
          btn.setAttribute('data-bs-toggle', 'modal');
          btn.setAttribute('data-bs-target', '#UpdateClientModal');
          document.body.appendChild(btn);
          btn.click();
          document.body.removeChild(btn);
        }
        
        // Limpar a busca para a próxima vez
        this.selectedSearchClient = null;
      });
    },
    async loadPage(page) {
      if (!page || page < 1) {
        page = 1;
      }
      this.currentPage = page;
      await this.setClientsList(page);
    },
    goToPage(page) {
      if (page < 1 || (this.getClientsPagination.last_page && page > this.getClientsPagination.last_page)) {
        return;
      }
      this.loadPage(page);
    },
    formatBirthDate(date) {
      // convert YYYY-MM-DD to DD/MM/YYYY
      if (!date) return '';
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    }
  }
});
</script>

<style>
body.dark .clients-create-btn {
  background: var(--splash-primary-color) !important;
  border: 1px solid rgba(167, 164, 255, 0.42) !important;
  box-shadow: 0 8px 18px rgba(101, 96, 240, 0.18) !important;
  color: #ffffff !important;
}

body.dark .clients-create-btn:hover,
body.dark .clients-create-btn:focus {
  background: #736ef5 !important;
  border-color: rgba(200, 198, 255, 0.58) !important;
  color: #ffffff !important;
}
</style>
